module.exports = __webpack_public_path__ + "img/score_bg3.e34a6b4.png";